import { Box, Typography } from "@mui/material";

// updated
export default function CardInformation(props: {
    title: string | JSX.Element;
    value: string | number | JSX.Element;
}) {
    return (
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
            <Typography color="text.secondary" sx={{ fontSize: 12 }}>
                {props.title}
            </Typography>
            <span
                style={{
                    flexGrow: 1,
                    margin: "0 16px",
                    borderBottom: "1px dashed rgba(0,0,0, 0.1)",
                }}
            ></span>
            <Typography noWrap sx={{ fontSize: 12 }}>
                {props.value}
            </Typography>
        </Box>
    );
}
